import { useQuery } from '@tanstack/react-query'

import { useLegacyPublicApi } from '@/services/api/ApiContext'

import { getBrandTheme } from '@/mock/brandsTheme/definitions'
import { THEME_PATH } from '@/services'

export const useGetTheme = ({ themeId }, config = {}) => {
  const api = useLegacyPublicApi()
  return useQuery({
    queryKey: ['get-theme', themeId],
    queryFn: async () => {
      if (!api || !themeId) return null
      if (process.env.NODE_ENV === 'development') {
        return getBrandTheme(themeId)
      } else {
        const { data } = await api.get(THEME_PATH.replace('{themeId}', themeId))
        return data
      }
    },
    ...config,
  })
}

export default useGetTheme
